export const CARD_SHADOW = '0.25rem 0.1rem 0.2rem #ccc;';
